import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=44154837"
import script from "./Trips.vue?vue&type=script&lang=ts"
export * from "./Trips.vue?vue&type=script&lang=ts"
import style0 from "./Trips.vue?vue&type=style&index=0&id=44154837&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports